"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceUtils = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const isSameOrAfter_js_1 = __importDefault(require("dayjs/plugin/isSameOrAfter.js"));
const timezone_js_1 = __importDefault(require("dayjs/plugin/timezone.js"));
const utc_js_1 = __importDefault(require("dayjs/plugin/utc.js"));
dayjs_1.default.extend(utc_js_1.default);
dayjs_1.default.extend(timezone_js_1.default);
dayjs_1.default.extend(isSameOrAfter_js_1.default);
class PriceUtils {
    static format(price, { accuracy } = { accuracy: 2 }) {
        return new Intl.NumberFormat(PriceUtils.getLocaleForCurrency(price.currency), {
            style: 'currency',
            currency: price.currency,
            minimumFractionDigits: accuracy,
            currencyDisplay: 'narrowSymbol',
        }).format(price.value);
    }
    static getLocaleForCurrency(currency) {
        switch (currency) {
            case 'CAD':
                return 'en-CA';
            case 'USD':
                return 'en-US';
            default:
                return 'fr-FR';
        }
    }
}
exports.PriceUtils = PriceUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpY2UudXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvcHJpY2UtdXRpbHMvcHJpY2UudXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBQXlCO0FBQ3pCLHFGQUF5RDtBQUN6RCwyRUFBK0M7QUFDL0MsaUVBQXFDO0FBRXJDLGVBQUssQ0FBQyxNQUFNLENBQUMsZ0JBQUcsQ0FBQyxDQUFBO0FBQ2pCLGVBQUssQ0FBQyxNQUFNLENBQUMscUJBQVEsQ0FBQyxDQUFBO0FBQ3RCLGVBQUssQ0FBQyxNQUFNLENBQUMsMEJBQWEsQ0FBQyxDQUFBO0FBVTNCLE1BQWEsVUFBVTtJQUNyQixNQUFNLENBQUMsTUFBTSxDQUFDLEtBQVksRUFBRSxFQUFFLFFBQVEsS0FBb0IsRUFBRSxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZFLE9BQU8sSUFBSSxJQUFJLENBQUMsWUFBWSxDQUFDLFVBQVUsQ0FBQyxvQkFBb0IsQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLEVBQUU7WUFDNUUsS0FBSyxFQUFFLFVBQVU7WUFDakIsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRO1lBQ3hCLHFCQUFxQixFQUFFLFFBQVE7WUFDL0IsZUFBZSxFQUFFLGNBQWM7U0FDaEMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDeEIsQ0FBQztJQUVPLE1BQU0sQ0FBQyxvQkFBb0IsQ0FBQyxRQUFnQjtRQUNsRCxRQUFRLFFBQVEsRUFBRSxDQUFDO1lBQ2pCLEtBQUssS0FBSztnQkFDUixPQUFPLE9BQU8sQ0FBQTtZQUNoQixLQUFLLEtBQUs7Z0JBQ1IsT0FBTyxPQUFPLENBQUE7WUFDaEI7Z0JBQ0UsT0FBTyxPQUFPLENBQUE7UUFDbEIsQ0FBQztJQUNILENBQUM7Q0FDRjtBQXBCRCxnQ0FvQkMifQ==